<template>
  <div>
    <el-row type="flex" class="logbox" justify="center">
      <el-col :span="24" class="logx">
        <el-row class="log" @click.native.prevent="switchLogin()">切换账号</el-row>
        <el-row class="log" @click.native.prevent="openDiaPwd()">修改密码</el-row>
        <el-row class="log" @click.native.prevent="privateInfo()">个人信息</el-row>
      </el-col>
    </el-row>
    <updatePwd :updateDialogVisable="updateDialogVisable" @closeDiaPwd="closeDiaPwd" @closelogm="closelogm"></updatePwd>
    <updatePersonalInfo v-if="updatePersonalInfodialogVisible" :updatePersonalInfodialogVisible="updatePersonalInfodialogVisible" @closelogm="closePerInfo"/>
  </div>
</template>

<script>
import {
  removeToken
} from '../../../../util/auth';

import updatePwd from "./updatePwd.vue";
import updatePersonalInfo from "./updatePersonalInfo.vue";

export default {
  inject:['reload'],
  components:{
    updatePwd,
    updatePersonalInfo
  },
  data () {
    return {
       updateDialogVisable:false,
       updatePersonalInfodialogVisible: false,
       row: {}
    }
  },

  props:{
    loginVisible: Boolean,
  },

  methods: {
    switchLogin(){
      console.log("切换账号");
      removeToken();
      // login();
      // this.$router.go(0);
      location.reload();
      this.$emit("closeDialog",false);
    },
    openDiaPwd(){
      console.log("修改密码");
      this.$emit("closeDialog",true);
      this.updateDialogVisable=true;
    },
    closeDiaPwd(val){
      this.updateDialogVisable=val;
    },
    closelogm(val){
      this.$emit("closelogm",val);
    },
    closePerInfo(val) {
        this.updatePersonalInfodialogVisible = val
    },
    privateInfo() {
        this.updatePersonalInfodialogVisible = true

    }
  },

  created () {
  }
}
</script>

<style lang='less' scoped>
.el-row {
  cursor:pointer;
  width: 100%;
}
.el-col {
  width: 100%!important;
}
.logbox{
    text-align: center;
    width: 100%;
    .logx {
        height: 100%;
      .log {
          font-family: 'Microsoft Yahei';
          height:35px;
          line-height: 35px;
          text-align: center;
          font-size: 16px;
          letter-spacing: 2px;
          &:not(:last-child) {
            border-bottom: 1px solid #e3e3e3;
          }
      }
      
    }
  }
</style>